@if (companyLifeState(); as companyLifeState) {
  <nk-company-analysis-risk-layout [bgColor]="'red'">
    <div class="d-flex align-items-top justify-content-between w-100" header>
      <div>
        <h1 class="mb-0">
          @if (companyLifeState.mainState?.company_state_category?.company_state_category_key; as key) {
            {{ companyLifeStateTranslations[key] || '' | translate }}
          }
        </h1>
        <p class="mb-0">
          {{ companyLifeState.mainState?.company_state_timeline?.active_from_date | date: dateFormats.Standard }}
        </p>
      </div>
      <div>
        <h1>
          <nk-risk-level-icon [riskLevel]="'very_high'" class="d-inline-block ms-1"></nk-risk-level-icon>
        </h1>
      </div>
    </div>
    <div body>
      @if (companyStateTimelineComposites$ | async; as companyStateTimelineComposites) {
        <p class="text-muted text-uppercase">
          {{ 'bankruptcy_risk_score.history.title' | translate }}
        </p>
        <ul class="list-group list-group-flush small">
          @for (stateComposite of companyStateTimelineComposites; track stateComposite.uuid) {
            <li class="list-group-item ps-0 pe-0 d-flex justify-content-start align-items-top">
              <strong class="me-1" style="max-width: 55px">{{
                stateComposite.company_state_timeline.active_from_date | date
              }}</strong>
              {{ 'company_flag.' + stateComposite.company_state.company_state_category_key | translate }}
            </li>
          }
        </ul>
      } @else {
        <nk-company-analysis-risk-loading
          class="d-block w-100"
          [text]="'bankruptcy_risk_score.history.loading' | translate"></nk-company-analysis-risk-loading>
      }
    </div>
  </nk-company-analysis-risk-layout>
}
